import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { connect } from "react-redux";
import Loading from "../../Loading";
import {
  fetchCorporateEvents,
  unloadBookedEvents,
} from "../../../redux/actions";
import { token } from "../../../modules/auth";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { BOOKED_EVENT_STATUS } from "../../../constants";
import { mapBookedEventToCalendarEvent } from "../../../pages/admin/corporate/calendar-events/mapEvents";
import ViewEventModal from "../../corporate/ViewEventModal";
import ViewBookedEvent from "../../corporate/ViewBookedEvent";
import { ButtonPrimary } from "../../Button";
import * as VENUE_ROUTES from "../../../Router/venue_routes";
import EventWrapper from "../../../pages/admin/corporate/calendar-events/EventWrapper";
import VenueCalendarDashFilters from "./VenueCalendarDashFilters";

function VenueDashboardCalendar({
  isFetchingBookedEvents,
  fetchCorporateEvents,
  unloadBookedEvents,
  bookedEvents,
  token,
}) {
  const [event, setEvent] = useState(null);
  const [showEventModal, setShowEventModal] = useState(false);
  const [showBookedEventModal, setShowBookedEventModal] = useState(false);
  const currentDate = new Date();
  const [dateRangeForFetch, setDateRangeForFetch] = useState([
    new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
      .toISOString()
      .split("T")[0],
    new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0)
      .toISOString()
      .split("T")[0],
  ]);
  const formats = {
    monthHeaderFormat: (date, culture, localizer) =>
      localizer.format(date, "MMM yyyy"),
  };
  const localizer = momentLocalizer(moment);

  useEffect(() => {
    fetchCorporateEventsHandler();
  }, []);

  useEffect(() => {
    fetchCorporateEventsHandler();
  }, [dateRangeForFetch]);

  const fetchCorporateEventsHandler = () => {
    unloadBookedEvents();
    let queryParams = { dateRange: dateRangeForFetch };
    queryParams.eventStatus = [
      BOOKED_EVENT_STATUS.CONFIRMED,
      BOOKED_EVENT_STATUS.PENDING_INVOICE,
      BOOKED_EVENT_STATUS.COMPLETED,
    ];
    return fetchCorporateEvents(token, queryParams);
  };
  let eventsArray = [];
  let bookedEventsArray = bookedEvents?.map(globalEvent => {
    return mapBookedEventToCalendarEvent(globalEvent, "bookedEvents");
  });
  Array.prototype.push.apply(eventsArray, bookedEventsArray);

  const handleNavigate = useCallback(
    (date, view) => {
      const givenDate = new Date(date);
      const lastMonth = new Date(
        givenDate.getFullYear(),
        givenDate.getMonth() - 1,
        1
      );
      const nextMonth = new Date(
        givenDate.getFullYear(),
        givenDate.getMonth() + 2,
        0
      );
      setDateRangeForFetch([
        lastMonth.toISOString().split("T")[0],
        nextMonth.toISOString().split("T")[0],
      ]);
    },
    [dateRangeForFetch]
  );

  const handleEventModalClose = () => {
    setShowBookedEventModal(false);
    setShowEventModal(false);
  };

  const handleSelectEvent = event => {
    if (event.bookedEvent) {
      setShowBookedEventModal(true);
    } else {
      setShowEventModal(true);
    }
    setEvent(event);
  };

  return (
    <div className="relative mt-4">
      {isFetchingBookedEvents ? (
        <div className={"calendar-loader"}>
          <Loading />
        </div>
      ) : null}
      <Calendar
        className={"agency-calendar-dash"}
        formats={formats}
        views={["month"]}
        onNavigate={handleNavigate}
        popup
        events={eventsArray}
        onClick={{}}
        selectable
        onSelectEvent={event => handleSelectEvent(event)}
        step={60}
        showMultiDayTimes
        defaultDate={new Date()}
        localizer={localizer}
        components={{
          event: EventWrapper,
          toolbar: props => {
            return (
              <>
                <VenueCalendarDashFilters {...props} />
              </>
            );
          },
        }}
      />

      {showEventModal && (
        <ViewEventModal event={event} onClose={handleEventModalClose} />
      )}
      {showBookedEventModal && (
        <ViewBookedEvent event={event} onClose={handleEventModalClose} />
      )}

      <div className="mt-2">
        <a href={VENUE_ROUTES.FRONTEND.VENUE.CALENDAR}>
          <ButtonPrimary>View Full Calendar</ButtonPrimary>
        </a>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    ...state,
    ...state.bookedEvents,
    token: token(state),
  };
};

const mapDispatchToProps = {
  fetchCorporateEvents,
  unloadBookedEvents,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VenueDashboardCalendar);
